// Dùng chung cho banner dải trên cùng và dialog thông báo khai tử giao diện cũ.
// Lùi/đổi hạn chỉ cần sửa ở đây.
export const NEW_VERSION_URL = "https://zalo.salework.net/v2/";
export const SHUTDOWN_DATE = "01/11/2026";
